import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`data`}</strong><br />{`anything`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`the current state of the simulation`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`tick`}</strong><br />{`integer`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`the progress in the simulation`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`params`}</strong><br />{`object`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`all the parameters set by the user/author`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`cachedData`}</strong><br />{`object`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`data from previous `}<inlineCode parentName="td">{`ticks`}</inlineCode>{` of the simulation`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`results`}</strong><br />{`array`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`data from previous completed runs of the simulation`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`initData`}</strong><br />{`function`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`the Frame can reinitialize data`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`setData`}</strong><br />{`function`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`the Frame can change the data (so for instance the Frame can be used to let the user enter an initial state of data)`}</td>
        </tr>
      </tbody>
    </table>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      